import AdminHeader from "../../component/AdminHeader";
import Icons from "../../myIcon/Icons";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { useCallback, useEffect, useState } from "react";

export default function Dashboard() {

    const leadsEndpoint = ApiEndpoints.dashboard.dashboardcount;
    const MonthlyEndpoint = ApiEndpoints.dashboard.monthlycount;
    const [leadsCount, setLeadsCount] = useState(

        {
            "blog_count": "",
            "contact_count": "",
            "corporate_query_count": "",

        }
    );
    const [selectedMonths, setSelectedMonths] = useState({
        contact: "",
        corporatequery: "",
        aiblog: "",
    });
    const currentYear = new Date().getFullYear();
    const getLeadsCount = useCallback(async () => {
        try {
            const response = await ApiRequest("GET", leadsEndpoint);
            setLeadsCount(response);
            setSelectedMonths({
                contact: "",
                corporatequery: "",
                aiblog: "",
            });
        } catch (error) {
            console.error("Error fetching leads count:", error);
        }
    }, [leadsEndpoint]);

    //   Get Montly Count APi
    const getMonthlyCount = async (type, month, varType) => {
        try {
            const response = await ApiRequest("GET", `${MonthlyEndpoint}${varType}/${month}/${currentYear}`);
            setLeadsCount(prev => ({
                ...prev,
                [type]: response?.data?.Count ?? 0
            }));
        } catch (error) {
            console.error("Error fetching Monthly count Data:", error);
        }
    }

    useEffect(() => {
        getLeadsCount();

    }, [getLeadsCount])
    const handleMonthChange = (e, type, varType) => {
        const selectedMonth = e.target.value;
        setSelectedMonths(prev => ({
            ...prev,
            [varType]: selectedMonth,
        }));

        if (!selectedMonth) {
            getLeadsCount();
            return;
        }

        getMonthlyCount(type, selectedMonth, varType);

    };
    const handleResetClick = (e) => {
        e.preventDefault();
        getLeadsCount();
    };
    const pagename = {
        name: 'Dashboard',
        user: 'Admin',
        innerpage: 'Dashboard'
    }

    return (
        <>
            <AdminHeader pagename={pagename} />

            <div className="add-btn-section">
                <div className="row">
                    <div className="col-lg-4">
                        <div className="home-dashbox pink-card">
                            <div className="dashbox-month">
                                <span>Total Leads</span>
                                <div>
                                    <select value={selectedMonths.contact} onChange={(e) => handleMonthChange(e, "contact_count", "contact")}>
                                        <option hidden="" value="">Monthly</option>
                                        <option value="January">January</option>
                                        <option value="February">February</option>
                                        <option value="March">March</option>
                                        <option value="April">April</option>
                                        <option value="May">May</option>
                                        <option value="June">June</option>
                                        <option value="July">July</option>
                                        <option value="August">August</option>
                                        <option value="September">September</option>
                                        <option value="October">October</option>
                                        <option value="November">November</option>
                                        <option value="December">December</option>
                                    </select>
                                    <a href="#dashboard-reset" onClick={handleResetClick}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount.contact_count} </h4>
                            <div className="dashbox-link">
                                <p>Contact Us</p>
                                <Link to="contact">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" className="dash-wave" alt="wave" />
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="home-dashbox purple-card">
                            <div className="dashbox-month">
                                <span>Total Leads</span>
                                <div>
                                    <select value={selectedMonths.corporatequery} onChange={(e) => handleMonthChange(e, "corporate_query_count", "corporatequery")}>
                                        <option hidden="" value="">Monthly</option>
                                        <option value="January">January</option>
                                        <option value="February">February</option>
                                        <option value="March">March</option>
                                        <option value="April">April</option>
                                        <option value="May">May</option>
                                        <option value="June">June</option>
                                        <option value="July">July</option>
                                        <option value="August">August</option>
                                        <option value="September">September</option>
                                        <option value="October">October</option>
                                        <option value="November">November</option>
                                        <option value="December">December</option>
                                    </select>
                                    <a href="#dashboard-reset" onClick={handleResetClick}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount.corporate_query_count} </h4>
                            <div className="dashbox-link">
                                <p>Corporate Query</p>
                                <Link to="corporate-query">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" className="dash-wave" alt="wave" />
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="home-dashbox orange-card">
                            <div className="dashbox-month">
                                <span>Total Leads</span>
                                <div>
                                    <select value={selectedMonths.aiblog} onChange={(e) => handleMonthChange(e, "blog_count", "aiblog")}>
                                        <option hidden="" value="">Monthly</option>
                                        <option value="January">January</option>
                                        <option value="February">February</option>
                                        <option value="March">March</option>
                                        <option value="April">April</option>
                                        <option value="May">May</option>
                                        <option value="June">June</option>
                                        <option value="July">July</option>
                                        <option value="August">August</option>
                                        <option value="September">September</option>
                                        <option value="October">October</option>
                                        <option value="November">November</option>
                                        <option value="December">December</option>
                                    </select>
                                    <a href="#dashboard-reset" onClick={handleResetClick}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount.blog_count}</h4>
                            <div className="dashbox-link">
                                <p>Blog</p>
                                <Link to="blog">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" className="dash-wave" alt="wave" />
                        </div>
                    </div>

                    {/* <div className="col-lg-4">
              <div className="home-dashbox grey-card">
                  <div className="dashbox-month">
                      <span>Total Leads</span>
                      <div>
                          <select>
                              <option hidden="" value="">Monthly</option>
                              <option value="January">January</option>
                              <option value="February">February</option>
                              <option value="March">March</option>
                              <option value="April">April</option>
                              <option value="May">May</option>
                          </select>
                          <a href=""><Icons name="rotateRight" /></a>
                      </div>
                  </div>
                  <h4>110</h4>
                  <div className="dashbox-link">
                      <p>Blog</p>
                      <Link to="blog">See Full List</Link>
                  </div>
                  <img src="/assets/wave.webp" className="dash-wave" alt="wave"/>
              </div>
            </div> */}
                </div>
            </div>
        </>
    )
}
